// import React, { useEffect, useState } from "react";
// import { Col, Row } from "react-bootstrap";
// import Select from "react-select";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
// import edit from '../../../assets/images/Dashboard/edit-img.svg';
// import add from '../../../assets/images/Dashboard/add.svg'
// import { useDispatch, useSelector } from "react-redux";
// import { loadAssignedModulesDropdownData, loadCustomFieldsData, loadModuleData, loadModuleFieldNames, loadSubModuleData, loadSubModulesDropdownData, postCustomFieldsLabelNameChange } from "../../../redux/action";
// import * as HeaderAuthentication from "../../HeaderAuthentication";

// const FieldTable = () => {

//     const dispatch = useDispatch();
//     const { getCustomFields, getCompanyDropdown, assignedModulesDropdown, subModuleDropdown, getModuleFieldsNames } = useSelector((state) => state.data);

//     // const [customFields, setCustomFields] = useState(initialCustomFields);
//     const [customFields, setCustomFields] = useState([]);
//     const [editingIndex, setEditingIndex] = useState(null); // Track the index of the field being edited
//     const [editingValue, setEditingValue] = useState(""); // Track the value of the input field
//     const [loading, setLoading] = useState(true);
//     // const [selectedCompany, setSelectedCompany] = useState(null);
//     const [selectedModule, setSelectedModule] = useState(null);
//     const [selectedSubModule, setSelectedSubModule] = useState(null);
//     const [moduleFields, setModuleFields] = useState([]);

//     // const handleCheckboxChange = (moduleIndex, itemIndex) => {
//     //     const updatedModules = [...modules];
//     //     updatedModules[moduleIndex].items[itemIndex].checked = !updatedModules[moduleIndex].items[itemIndex].checked;
//     //     setModules(updatedModules);
//     // };

//     const handleCheckboxChange = (index) => {
//         setCustomFields((prevFields) =>
//             prevFields.map((field, fIndex) =>
//                 fIndex === index ? { ...field, checked: !field.checked } : field
//             )
//         );
//     };

//     // const handleCustomFieldChange = (index) => {
//     //     const updatedCustomFields = [...customFields];
//     //     updatedCustomFields[index].checked = !updatedCustomFields[index].checked;
//     //     setCustomFields(updatedCustomFields);
//     // };

//     // const handleEditClick = (index) => {
//     //     setEditingIndex(index);
//     //     setEditingValue(getCustomFields[index].LabelName); // Set editingValue to the current field's LabelName
//     // };

//     const handleEditClick = (index) => {
//         setEditingIndex(index);
//         setEditingValue(customFields[index]?.LabelName || "");
//     };

//     const handleInputChange = (e) => {
//         setEditingValue(e.target.value);
//     };

//     // const handleInputBlur = (index) => {
//     //     const updatedCustomFields = [...customFields];
//     //     updatedCustomFields[index].name = editingValue;
//     //     setCustomFields(updatedCustomFields);
//     //     setEditingIndex(null); // Exit edit mode
//     // };

//     const handleInputBlur = (index) => {
//         if (!editingValue.trim()) {
//             setEditingIndex(null);
//             return;
//         }

//         setCustomFields((prevFields) => {
//             const updatedFields = prevFields.map((field, fIndex) =>
//                 fIndex === index ? { ...field, LabelName: editingValue } : field
//             );
//             return [...updatedFields]; // New reference to trigger re-render
//         });

//         setEditingIndex(null);
//     };

//     useEffect(() => {
//         dispatch(loadCustomFieldsData(setLoading));
//         dispatch(loadAssignedModulesDropdownData());
//         // dispatch(loadSubModuleData(setLoading));
//     }, []);

//     useEffect(() => {
//         if (getCustomFields) {
//             setCustomFields(getCustomFields);
//         }
//     }, [getCustomFields]);

//     useEffect(() => {
//         if (getModuleFieldsNames?.length > 0) {
//             const updatedFields = getModuleFieldsNames.map(field => ({
//                 ...field,
//                 checked: field.StatusID === 69 // assuming 69 = checked
//             }));
//             setModuleFields(updatedFields);
//         }
//     }, [getModuleFieldsNames]);

//     // ✅ Handle company selection
//     // const handleCompanyChange = (selectedOption) => {
//     //     setSelectedCompany(selectedOption);
//     //     dispatch(loadCustomFieldsData(selectedOption?.value)); // Pass selected company ID
//     // };

//     // const handleCompanyChange = (selectedOption) => {
//     //     setSelectedCompany(selectedOption);
//     //     const selectedCompanyID = selectedOption?.value || null; // Ensure it's not undefined
//     //     // dispatch(loadCustomFieldsData(setLoading, null, null, selectedCompanyID,));
//     // };

//     const handleModuleChange = (selectedOption) => {
//         setSelectedModule(selectedOption);
//         const selectedModuleID = selectedOption?.value || null; // ✅ Ensure it's not undefined

//         if (selectedModuleID) {
//             dispatch(loadSubModulesDropdownData(selectedModuleID)); // ✅ Pass ModuleID only if it exists
//             // dispatch(loadCustomFieldsData(setLoading, null, null, selectedCompany?.value || null, selectedModuleID)); // ✅ Pass both CompanyID & ModuleID
//             dispatch(loadCustomFieldsData(setLoading, null, null, null, selectedModuleID)); // ✅ Pass both CompanyID & ModuleID
//             dispatch(loadModuleFieldNames(null, selectedModuleID, null));
//         }
//         setSelectedSubModule(null);
//     };

//     // Handle checkbox for module fields
//     const handleModuleFieldCheckboxChange = (index) => {
//         setModuleFields((prevFields) =>
//             prevFields.map((field, fIndex) =>
//                 fIndex === index ? { ...field, checked: !field.checked } : field
//             )
//         );
//     };

//     const handleSubModuleChange = (selectedOption) => {
//         setSelectedSubModule(selectedOption);
//         const selectedSubModuleID = selectedOption?.value || null; // Ensure it's not undefined

//         dispatch(
//             loadCustomFieldsData(
//                 setLoading,
//                 null,
//                 null,
//                 // selectedCompany?.value || null, // ✅ Company ID
//                 null, // ✅ Company ID
//                 selectedModule?.value || null, // ✅ Module ID
//                 selectedSubModuleID // ✅ Sub-Module ID (only if it exists)
//             )
//         );
//         dispatch(
//             loadModuleFieldNames(null, selectedModule?.value || null, selectedSubModuleID) // 👈 add this
//         );
//     };

//     const handleCustomFieldLabelChange = () => {
//         const updatedFields = customFields.map((field) => ({
//             CustomFields_IDPK: field.CustomFieldsID,
//             CustomFields_LabelName: field.LabelName,
//             CustomFields_StatusIDFK: field.checked ? 26 : 27,
//         }));

//         const data = { LstCustomField: updatedFields };

//         let requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(data),
//         };

//         dispatch(postCustomFieldsLabelNameChange(requestOption));
//     };

//     return (
//         <Row className="module-management-container">
//             <Row className="justify-content-between">
//                 <Col md={4} className="p-0">
//                     <h6>Fields Enable / Disable</h6>
//                 </Col>
//                 {/* <Col md={3} className="p-0">
//                     <Select
//                         className="react-select-container"
//                         classNamePrefix="react-select"
//                         placeholder="Select Client"
//                         options={getCompanyDropdown}
//                         value={selectedCompany}
//                         onChange={handleCompanyChange}
//                     />
//                 </Col> */}
//             </Row>
//             <Row className="module-management-select">
//                 <Col md={3}>
//                     <div>
//                         <label>Module</label>
//                         <Select
//                             className="react-select-container"
//                             classNamePrefix="react-select"
//                             // placeholder="Customer Management"
//                             options={assignedModulesDropdown}
//                             value={selectedModule}
//                             onChange={handleModuleChange}
//                         />
//                     </div>
//                 </Col>
//                 <Col md={3}>
//                     <div>
//                         <label>Sub-Modules</label>
//                         <Select
//                             className="react-select-container"
//                             classNamePrefix="react-select"
//                             // placeholder="Customer Management"
//                             options={subModuleDropdown}
//                             value={selectedSubModule}
//                             onChange={handleSubModuleChange}
//                         />
//                     </div>
//                 </Col>
//             </Row>
//             <div className="fields-container">
//                 {getModuleFieldsNames && getModuleFieldsNames.length > 0 ? (
//                     <Row className="fields-container-inner">
//                         {getModuleFieldsNames.map((item, itemIndex) => (
//                             <Col md={4} key={itemIndex} className="modules-grid mb-2">
//                                 <div className="form-check">
//                                     <input
//                                         className="form-check-input"
//                                         type="checkbox"
//                                         id={`module-item-${itemIndex}`}
//                                         checked={item.checked}
//                                         onChange={() => handleModuleFieldCheckboxChange(itemIndex)}
//                                     />
//                                     <label className="form-check-label" htmlFor={`module-item-${itemIndex}`}>
//                                         {item.ModuleFieldAliasName}
//                                     </label>
//                                 </div>
//                             </Col>
//                         ))}
//                     </Row>
//                 ) : (
//                     <p className="text-center text-muted">No module fields available.</p>
//                 )}
//             </div>

//             <div className="pt-2 p-0">
//                 <Row className="pt-2 pb-2">
//                     <Col md={12}>
//                         <h6>Custom Fields</h6>
//                     </Col>
//                 </Row>
//                 <div className="fields-container">
//                     {customFields?.length > 0 ? (
//                         <Row className="fields-container-inner">
//                             {customFields.map((field, index) => (
//                                 <Col md={4} key={index} className="modules-grid mb-2">
//                                     <div className="form-check">
//                                         <input
//                                             className="form-check-input"
//                                             type="checkbox"
//                                             id={`custom-item-${index}`}
//                                             checked={field.checked}
//                                             onChange={() => handleCheckboxChange(index)}
//                                         />
//                                         {editingIndex === index ? (
//                                             <div className="menubar-fields-text-box-div">
//                                                 <input
//                                                     type="text"
//                                                     value={editingValue}
//                                                     onChange={handleInputChange}
//                                                     onBlur={() => handleInputBlur(index)}
//                                                     autoFocus
//                                                     className="form-control"
//                                                 />
//                                                 <img src={add} alt="" className="add-custom-icon" />
//                                             </div>
//                                         ) : (
//                                             <>
//                                                 <label className="form-check-label" htmlFor={`custom-item-${index}`}>
//                                                     {field.LabelName}
//                                                 </label>
//                                                 &nbsp;&nbsp;
//                                                 <img
//                                                     src={edit}
//                                                     alt="Edit"
//                                                     onClick={() => handleEditClick(index)}
//                                                     style={{ cursor: 'pointer' }}
//                                                     className="custom-field-edit-icon"
//                                                 />
//                                             </>
//                                         )}
//                                     </div>
//                                 </Col>
//                             ))}
//                         </Row>
//                     ) : (
//                         <p className="text-center text-muted">No custom fields available.</p>
//                     )}
//                 </div>
//             </div>
//             <Row className="mt-4">
//                 <Col className="field-table-btn-container">
//                     <SbCancelBtn btnName="Cancel" />
//                     <SBSaveUpdateBtn btnName="Save" onClickEffect={handleCustomFieldLabelChange} />
//                 </Col>
//             </Row>
//         </Row>
//     );
// };

// export default FieldTable;






import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import edit from '../../../assets/images/Dashboard/edit-img.svg';
import add from '../../../assets/images/Dashboard/add.svg';
import { useDispatch, useSelector } from "react-redux";
import {
    loadAssignedModulesDropdownData,
    loadCustomFieldsData,
    loadModuleFieldNames,
    loadSubModulesDropdownData,
    postCustomFieldsLabelNameChange,
    postModuleFieldNamesData
} from "../../../redux/action";
import * as HeaderAuthentication from "../../HeaderAuthentication";

const FieldTable = () => {
    const dispatch = useDispatch();
    const {
        getCustomFields,
        getCompanyDropdown,
        assignedModulesDropdown,
        subModuleDropdown,
        getModuleFieldsNames
    } = useSelector((state) => state.data);

    const [customFields, setCustomFields] = useState([]);
    const [moduleFields, setModuleFields] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editingValue, setEditingValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedModule, setSelectedModule] = useState(null);
    const [selectedSubModule, setSelectedSubModule] = useState(null);

    // Handle checkbox for custom fields
    const handleCustomFieldCheckboxChange = (index) => {
        setCustomFields((prevFields) =>
            prevFields.map((field, fIndex) =>
                fIndex === index ? { ...field, checked: !field.checked } : field
            )
        );
    };

    // Handle checkbox for module fields
    const handleModuleFieldCheckboxChange = (index) => {
        setModuleFields((prevFields) =>
            prevFields.map((field, fIndex) =>
                fIndex === index ? { ...field, checked: !field.checked } : field
            )
        );
    };

    const handleEditClick = (index) => {
        setEditingIndex(index);
        setEditingValue(customFields[index]?.LabelName || "");
    };

    const handleInputChange = (e) => {
        setEditingValue(e.target.value);
    };

    const handleInputBlur = (index) => {
        if (!editingValue.trim()) {
            setEditingIndex(null);
            return;
        }

        setCustomFields((prevFields) => {
            const updatedFields = prevFields.map((field, fIndex) =>
                fIndex === index ? { ...field, LabelName: editingValue } : field
            );
            return [...updatedFields];
        });

        setEditingIndex(null);
    };

    useEffect(() => {
        // dispatch(loadCustomFieldsData(setLoading));
        dispatch(loadAssignedModulesDropdownData());
    }, []);

    useEffect(() => {
        if (getCustomFields) {
            const updatedFields = getCustomFields.map(field => ({
                ...field,
                checked: field.StatusIDFK === 26 // assuming 26 = checked, 27 = unchecked
            }));
            setCustomFields(updatedFields);
        }
        else {
            setCustomFields([]);
        }
    }, [getCustomFields]);

    useEffect(() => {
        if (getModuleFieldsNames?.length > 0) {
            const updatedFields = getModuleFieldsNames.map(field => ({
                ...field,
                checked: field.StatusID === 69 // assuming 69 = checked
            }));
            setModuleFields(updatedFields);
        }
        else {
            setModuleFields([]); // ✅ reset when empty
        }
    }, [getModuleFieldsNames]);

    const handleModuleChange = (selectedOption) => {
        setSelectedModule(selectedOption);
        const selectedModuleID = selectedOption?.value || null;

        if (selectedModuleID) {
            dispatch(loadSubModulesDropdownData(selectedModuleID));
            dispatch(loadCustomFieldsData(setLoading, null, null, null, selectedModuleID));
            dispatch(loadModuleFieldNames(null, selectedModuleID, null));
        }
        setSelectedSubModule(null);
    };

    const handleSubModuleChange = (selectedOption) => {
        setSelectedSubModule(selectedOption);
        const selectedSubModuleID = selectedOption?.value || null;

        dispatch(
            loadCustomFieldsData(
                setLoading,
                null,
                null,
                null,
                selectedModule?.value || null,
                selectedSubModuleID
            )
        );
        dispatch(loadModuleFieldNames(null, selectedModule?.value || null, selectedSubModuleID));
    };

    const handleCustomFieldLabelChange = () => {
        const updatedFields = customFields.map((field) => ({
            CustomFields_IDPK: field.CustomFieldsID,
            CustomFields_LabelName: field.LabelName,
            CustomFields_StatusIDFK: field.checked ? 26 : 27,
        }));

        const data = { LstCustomField: updatedFields };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postCustomFieldsLabelNameChange(requestOption));
    };

    const handleModuleFieldSave = () => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CompanyID = null;

        // Determine CompanyID based on SignInType
        if (signInDetails?.[0]?.SignInType === "SuperAdmin") {
            CompanyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "ClientAdmin") {
            CompanyID = signInDetails?.[0]?.CompanyID;
        } else if (signInDetails?.[0]?.SignInType === "User") {
            CompanyID = signInDetails?.[0]?.CompanyID;
        }

        const LstCompanyModuleField = moduleFields.map((field) => ({
            ModuleFieldID: field.ModuleFieldID,
            StatusID: field.checked ? 69 : 70,
        }));

        const data = {
            CompanyID,
            LstCompanyModuleField,
        };

        const requestOption = {
            method: "POST",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postModuleFieldNamesData(requestOption));
    };

    return (
        <Row className="module-management-container">
            <Row className="justify-content-between">
                <Col md={4} className="p-0">
                    <h6>Fields Enable / Disable</h6>
                </Col>
            </Row>

            <Row className="module-management-select">
                <Col md={3}>
                    <label>Module</label>
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={assignedModulesDropdown}
                        value={selectedModule}
                        onChange={handleModuleChange}
                    />
                </Col>
                <Col md={3}>
                    <label>Sub-Modules</label>
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={subModuleDropdown}
                        value={selectedSubModule}
                        onChange={handleSubModuleChange}
                    />
                </Col>
            </Row>

            <div className="fields-container">
                {moduleFields.length > 0 ? (
                    <Row className="fields-container-inner">
                        {moduleFields.map((item, itemIndex) => (
                            <Col md={4} key={itemIndex} className="modules-grid mb-2">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`module-item-${itemIndex}`}
                                        // checked={item.checked || item.IsRequired}
                                        checked={item.checked}
                                        onChange={() => handleModuleFieldCheckboxChange(itemIndex)}
                                        disabled={item.IsRequired}
                                    />
                                    <label className="form-check-label" htmlFor={`module-item-${itemIndex}`}>
                                        {item.ModuleFieldAliasName}
                                    </label>
                                </div>
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <p className="text-center text-muted">No module fields available.</p>
                )}
            </div>

            <div className="pt-2 p-0">
                <Row className="pt-2 pb-2">
                    <Col md={12}>
                        <h6>Custom Fields</h6>
                    </Col>
                </Row>
                <div className="fields-container">
                    {customFields.length > 0 ? (
                        <Row className="fields-container-inner">
                            {customFields.map((field, index) => (
                                <Col md={4} key={index} className="modules-grid mb-2">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`custom-item-${index}`}
                                            checked={field.checked}
                                            onChange={() => handleCustomFieldCheckboxChange(index)}
                                        />
                                        {editingIndex === index ? (
                                            <div className="menubar-fields-text-box-div">
                                                <input
                                                    type="text"
                                                    value={editingValue}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleInputBlur(index)}
                                                    autoFocus
                                                    className="form-control"
                                                />
                                                <img src={add} alt="" className="add-custom-icon" />
                                            </div>
                                        ) : (
                                            <>
                                                <label className="form-check-label" htmlFor={`custom-item-${index}`}>
                                                    {field.LabelName}
                                                </label>
                                                &nbsp;&nbsp;
                                                <img
                                                    src={edit}
                                                    alt="Edit"
                                                    onClick={() => handleEditClick(index)}
                                                    style={{ cursor: 'pointer' }}
                                                    className="custom-field-edit-icon"
                                                />
                                            </>
                                        )}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <p className="text-center text-muted">No custom fields available.</p>
                    )}
                </div>
            </div>

            <Row className="mt-4">
                <Col className="field-table-btn-container">
                    <SbCancelBtn btnName="Cancel" />
                    {/* <SBSaveUpdateBtn btnName="Save" onClickEffect={handleCustomFieldLabelChange} /> */}
                    <SBSaveUpdateBtn btnName="Save" onClickEffect={() => {
                        handleCustomFieldLabelChange();
                        handleModuleFieldSave();
                    }} />
                </Col>
            </Row>
        </Row>
    );
};

export default FieldTable;


